/* CEREBRO · seguimiento de pedido.
   Abre el rastreador con el numero que pega el cliente. No manda nada a ningun
   sitio por su cuenta: es el cliente quien decide pulsar, y el numero no sale
   del navegador hasta entonces. Sin correo ni numero de pedido: son datos
   personales y no hacen falta para esto. */
(function () {
  'use strict';
  document.querySelectorAll('[data-vf-track]').forEach(function (form) {
    var plantilla = form.dataset.url || '';
    if (!plantilla) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var campo = form.querySelector('[data-vf-track-num]');
      var num = campo ? campo.value.trim() : '';
      if (!num) { if (campo) campo.focus(); return; }
      // Solo letras, digitos y guiones: un numero de seguimiento no lleva otra cosa.
      if (!/^[A-Za-z0-9-]{5,40}$/.test(num)) {
        campo.setCustomValidity('Revisa el número: solo letras, números y guiones.');
        campo.reportValidity();
        return;
      }
      campo.setCustomValidity('');
      window.open(plantilla.replace('[numero]', encodeURIComponent(num)), '_blank', 'noopener');
    });
    var campo = form.querySelector('[data-vf-track-num]');
    if (campo) campo.addEventListener('input', function () { campo.setCustomValidity(''); });
  });
})();
